// JsFromRoutes CacheKey b99475584c216b1cb524fdd32009f8ca
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/gift_ideas/search'),
  moveUp: /* #__PURE__ */ definePathHelper('put', '/admin/consumer/gift_ideas/:id/move_up'),
  moveDown: /* #__PURE__ */ definePathHelper('put', '/admin/consumer/gift_ideas/:id/move_down'),
  duplicate: /* #__PURE__ */ definePathHelper('put', '/admin/consumer/gift_ideas/:id/duplicate'),
  updateGiftTags: /* #__PURE__ */ definePathHelper('put', '/admin/consumer/gift_ideas/:id/gift_tags'),
  taglineTypeahead: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/gift_ideas/tagline_typeahead'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/gift_ideas'),
  create: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/gift_ideas'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/consumer/gift_ideas/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/admin/consumer/gift_ideas/:id'),
}
